import React from 'react';
import { useCallback } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

// Salt única para a aplicação
const SALT = 'tooltip-salt';

/**
 * Cria um hash simples a partir de uma string
 * @param {string} str - String para fazer hash
 * @param {string} salt - Salt para adicionar ao hash
 * @returns {string} - String com hash
 */
const hashString = (str, salt) => {
  const text = `${str}${salt}`;
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    const char = text.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Converte para inteiro de 32 bits
  }
  return `tooltip-${Math.abs(hash).toString(36)}`;
};

/**
 * Hook que retorna a função `withTooltip`
 * Esta função recebe um texto e um elemento JSX, retornando o elemento
 * envolvido com um tooltip contendo o texto fornecido
 *
 * @returns {{ withTooltip: (text: string, jsx: React.ReactNode) => React.ReactElement }}
 */
export function useTooltip() {
  const withTooltip = useCallback((text, jsx) => {
    // Gera um ID único baseado no texto do tooltip
    const id = hashString(text, SALT);

    return (
      <>
        <span id={id}>{jsx}</span>
        <UncontrolledTooltip target={id}>{text}</UncontrolledTooltip>
      </>
    );
  }, []);

  return { withTooltip };
}
